import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import GeometryCollection from '../GeometryCollection';
var ShortCircuitedGeometryVisitor = /*#__PURE__*/function () {
  function ShortCircuitedGeometryVisitor() {
    _classCallCheck(this, ShortCircuitedGeometryVisitor);
    ShortCircuitedGeometryVisitor.constructor_.apply(this, arguments);
  }
  _createClass(ShortCircuitedGeometryVisitor, [{
    key: "applyTo",
    value: function applyTo(geom) {
      for (var i = 0; i < geom.getNumGeometries() && !this._isDone; i++) {
        var element = geom.getGeometryN(i);
        if (!(element instanceof GeometryCollection)) {
          this.visit(element);
          if (this.isDone()) {
            this._isDone = true;
            return null;
          }
        } else {
          this.applyTo(element);
        }
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._isDone = false;
    }
  }]);
  return ShortCircuitedGeometryVisitor;
}();
export { ShortCircuitedGeometryVisitor as default };